import React, { useEffect, useState } from "react";
import TextInput from "../../common/textinput";
import RadioInput from "../../common/radio-input";
import Dropdown from "../../common/dropdown";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import Checkbox from "../../common/checkbox";
import WidgetLoader from "../../common/widgetloader";
import {
    gasAvailabilityOptions,
    helpIcons,
} from "../../../constants/dropdown/calculations";
import { RegionItem } from "../../../store/model/calculations/calculation";
import useFluidFacade from "../../../facade/calculation/calculation-input/fluid.Facade";
import Notification from "../../common/notification";
import useCollapseFacade from "../../../facade/collapse.Facade";
import Accordion from "../../common/accordion";
import { initialFluidTabState } from "../../../store/model/calculations/fluid";
import { toast,ToastContainer } from "react-toastify";
import Error from '../../../assets/icons/Error';


const Fluid: React.FC = () => {
    const { loading } = useAppSelector((state) => state?.calculations);
    const {
        updateSpGrWater,
        updateWaterCut,
        updateOilAPI,
        updateSpGrOil,
        updateFluidViscosity,
        updateGasProduction,
        updateGOR,
        updateGLR,
        updateSpGrGas,
        updateGasCompressibility,
        updateBubblePoint,
        updateBottleHoleTemp,
        updateSurfaceTemp,
        updateRegion,
        updateSelectedRegion,
        updateGasAvailability,
        updateHiddenAutoGasComprss,
        updateHiddenBubblePoint,
        updateHiddenOilIpType,
        updateHiddenGasIp,
        updatedGetSelectedRegion,
    } = useFluidFacade();
    const { tab3Input, region, regionList } = useAppSelector(
        (state) => state?.fluid
    );

    const [fluidTab, setFluidTab] = useState<initialFluidTabState>({
        spGrWater: 0,
        waterCut: 0,
        bwpd: 0,
        oilAPI: 0,
        spGrOil: 0,
        oilCut: 0,
        bopd: 0,
        averageCombinedSpGr: 0,
        liquidPhaseCombinedSpGr: 0,
        fluidViscosity: 0,
        gasProduction: 0,
        gor: 0,
        glr: 0,
        spGrGas: 0,
        gasCompressibility: 0,
        bubblePoint: 0,
        bottomHoleTemp: 0,
        surfaceTemperature: 0,
        region: "",
    });
    const [error, setErrors] = useState({ waterCut: '' });

    const [isGasavailabilityOpen, setIsGasAvailabilityOpen] = useState<{
        show: boolean;
        id: string;
        value: string;
    }>({
        show: true,
        id: "1",
        value: "Yes",
    });
    const [notification, setNotification] = useState({
        show: false,
        message: "",
        type: "",
    });
    const [fluidVis, setFluidVis] = useState("");

    useEffect(() => {
        if (tab3Input) {
            setFluidTab((prev) => ({
                ...prev,
                spGrWater: Number(tab3Input?.spGrWater) || 0,
                waterCut: Number(tab3Input?.waterCut) || 0,
                bwpd: Number(tab3Input?.bwpd) || 0,
                oilAPI: Number(tab3Input?.oilAPI) || 0,
                spGrOil: Number(tab3Input?.spGrOil) || 0,
                oilCut: Number(tab3Input?.oilCut) || 0,
                bopd: Number(tab3Input?.bopd) || 0,
                averageCombinedSpGr: Number(tab3Input?.averageCombinedSpGr) || 0,
                liquidPhaseCombinedSpGr: Number(tab3Input?.liquidPhaseCombinedSpGr) || 0,
                fluidViscosity: Number(tab3Input?.fluidViscosity) || 0,
                gasProduction: Number(tab3Input?.gasProduction) || 0,
                gor: Number(tab3Input?.gor) || 0,
                glr: Number(tab3Input?.glr) || 0,
                spGrGas: Number(tab3Input?.spGrGas) || 0,
                gasCompressibility: Number(tab3Input?.gasCompressibility) || 0,
                bubblePoint: Number(tab3Input?.bubblePoint) || 0,
                bottomHoleTemp: Number(tab3Input?.bottomHoleTemp) || 0,
                surfaceTemperature: Number(tab3Input?.surfaceTemperature) || 0,
                region: region || "",
            }))
        }
    }, [tab3Input]);

    let selectedRegionList = regionList?.find((x: any) => x?.id === region);
    useEffect(() => {
        updatedGetSelectedRegion(selectedRegionList);
    }, [selectedRegionList]);

    const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e?.target.name === "oilAPI" && e?.target?.checked) {
            updateHiddenOilIpType("0");
        } else if (e?.target?.name === "spGrOil" && e?.target?.checked) {
            updateHiddenOilIpType("1");
        } else if (e?.target.name === "gasProduction" && e?.target?.checked) {
            updateHiddenGasIp("0");
        } else if (e?.target.name === "gor" && e?.target?.checked) {
            updateHiddenGasIp("1");
        } else if (e?.target.name === "glr" && e?.target?.checked) {
            updateHiddenGasIp("2");
        } else {
            updateHiddenGasIp(tab3Input?.hiddenGasIPType ?? "");
            updateHiddenOilIpType(tab3Input?.hiddenOilIPType ?? "");
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        const positiveNumberRegex = /^\d*\.?\d*$/;
        if (value === "") {
            setFluidTab((prev) => ({ ...prev, [name]: "" }));
            setErrors((prev) => ({ ...prev, [name]: "" }));
            return;
        }
        if (!positiveNumberRegex.test(value)) {
            return;
        }
        if (name === "waterCut" && value !== "") {
            const waterCutValue = Number(value);
            if (waterCutValue < 0 || waterCutValue > 100) {
              toast.error("Please provide value less than 100.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                icon: <Error />,
                style: {
                  background: "#f04438",
                  color: "#fff",
                  fontWeight: "bold",
                  fontFamily: "Mulish",
                  fontSize: "16px",
                },
              });
              setErrors((prev) => ({ ...prev, waterCut: "" }));
              return;
            } else {
              setErrors((prev) => ({ ...prev, waterCut: "" }));
            }
          }
        setFluidTab((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name } = e?.target;
        if (name === "spGrWater") {
            updateSpGrWater(Number(fluidTab?.spGrWater));
        } else if (name === "waterCut") {
            updateWaterCut(Number(fluidTab?.waterCut));
        } else if (name === "oilAPI") {
            updateOilAPI(Number(fluidTab?.oilAPI));
        } else if (name === "spGrOil") {
            updateSpGrOil(Number(fluidTab?.spGrOil));
        } else if (name === "spGrGas") {
            updateSpGrGas(Number(fluidTab?.spGrGas));
        } else if (name === "gasCompressibility") {
            updateGasCompressibility(Number(fluidTab?.gasCompressibility));
        } else if (name === "surfaceTemperature") {
            updateSurfaceTemp(Number(fluidTab?.surfaceTemperature));
        } else if (name === "fluidViscosity") {
            updateFluidViscosity(Number(fluidTab?.fluidViscosity));
            if (fluidTab?.fluidViscosity === "") {
                setNotification((prev) => ({
                    ...prev,
                    show: true,
                    message:
                        "Fluid Viscosity is required. Defaulting it back to initial calculated value.",
                    type: "info",
                }));
            }
        } else if (name === "gasProduction") {
            updateGasProduction(Number(fluidTab?.gasProduction));
        } else if (name === "gor") {
            updateGOR(Number(fluidTab?.gor));
        } else if (name === "glr") {
            updateGLR(Number(fluidTab?.glr));
        } else if (name === "bubblePoint") {
            updateBubblePoint(Number(fluidTab?.bubblePoint));
        } else if (name === "bottomHoleTemp") {
            updateBottleHoleTemp(Number(fluidTab?.bottomHoleTemp));
        }
    };

    const handleGasSelect = (option: RegionItem) => {
        if (option?.name === "No") {
            setIsGasAvailabilityOpen((prev) => ({
                ...prev,
                show: false,
                id: option?.id,
                value: option?.name,
            }));
            updateGasAvailability("0");
            updateHiddenGasIp("");
        } else {
            setIsGasAvailabilityOpen((prev) => ({
                ...prev,
                show: true,
                id: option?.id,
                value: option?.name,
            }));
            updateGasAvailability("1");
            updateHiddenGasIp(tab3Input?.hiddenGasIPType || "0");
        }
    };

    const handleCheckbox = (
        e: React.ChangeEvent<HTMLInputElement>,
        option: "gasCompressibility" | "bubblePoint"
    ) => {
        if (option === "gasCompressibility") {
            if (e.target.checked) {
                updateHiddenAutoGasComprss("1");
                updateGasCompressibility(0);
            } else {
                updateHiddenAutoGasComprss("0");
                updateGasCompressibility(tab3Input?.gasCompressibility ?? 0);
            }
        } else if (option === "bubblePoint") {
            if (e.target.checked) {
                updateHiddenBubblePoint("1");
            } else {
                updateHiddenBubblePoint("0");
            }
        }
    };

    const {
        updateFluidCollapse,
        updateOilPropertyCollapse,
        updateGasPropertyCollapse,
        updateGasVolumeCollapse,
        updateOthersCollapse,
        updateCorrelationCollapse,
    } = useCollapseFacade();

    const {
        fluidCollapse,
        oilPropertyCollapse,
        gasPropertyCollapse,
        gasVolumeCollapse,
        othersCollapse,
        correlationCollapse,
    } = useAppSelector((state) => state?.collapse);

    const handleCollapseChange = (key: boolean, name: string) => {
        if (name === "fluid") updateFluidCollapse(key);
        else if (name === "oilProperty") updateOilPropertyCollapse(key);
        else if (name === "gasProperty") updateGasPropertyCollapse(key);
        else if (name === "gasVolume") updateGasVolumeCollapse(key);
        else if (name === "others") updateOthersCollapse(key);
        else if (name === "correlations") updateCorrelationCollapse(key);
    };

    return (
        <>
            {loading ? (
                <div className="absolute inset-0 flex justify-center items-center bg-darkcolor-700 bg-opacity-30">
                    <WidgetLoader isLoading={loading} />
                </div>
            ) : (
                <div className="flex flex-col gap-[16px]">
                    <Accordion
                        title="Fluid"
                        isOpen={fluidCollapse}
                        onToggle={() => handleCollapseChange(!fluidCollapse, "fluid")}
                        content={
                            <>
                            <ToastContainer position='top-right' />
                            <div className="flex flex-col gap-[16px] p-[12px]">
                                <TextInput
                                    label="SpGrWater"
                                    placeholder={
                                        "Enter SpGrWater"
                                    }
                                    value={fluidTab?.spGrWater || ""}
                                    onChange={(e) => handleInputChange(e)}
                                    onBlur={(e) => handleBlur(e)}
                                    name="spGrWater"
                                    icon={helpIcons}
                                    required
                                    link={'/help/#specific-gravity-of-water'}
                                />
                                <TextInput
                                    label="WaterCut"
                                    placeholder={"Enter WaterCut"}
                                    value={fluidTab?.waterCut || ""}
                                    name="waterCut"
                                    onChange={(e) => handleInputChange(e)}
                                    onBlur={(e) => handleBlur(e)}
                                    unit={tab3Input?.actNameWaterCut || '%'}
                                    error={error.waterCut}
                                    required
                                />
                                <div className="flex justify-between text-neutral-25">
                                    <label>BWPD</label>
                                    <label>{`${tab3Input?.bwpd} ${tab3Input?.actNameBWPD || 'bpd'}`}</label>
                                </div>
                                <Accordion
                                    title="Oil property"
                                    isOpen={oilPropertyCollapse}
                                    onToggle={() =>
                                        handleCollapseChange(!oilPropertyCollapse, "oilProperty")
                                    }
                                    content={
                                        <div className="flex flex-col gap-[16px] p-[12px] radio">
                                            <RadioInput
                                                label="Oil API"
                                                radioName="oilAPI"
                                                name="oilAPI"
                                                onInputChange={(e) => handleInputChange(e)}
                                                onRadioChange={(e) => handleRadioChange(e)}
                                                onBlur={(e) => handleBlur(e)}
                                                checked={tab3Input?.hiddenOilIPType === "0"}
                                                inputValue={fluidTab?.oilAPI ?? ""}
                                                disabled={tab3Input?.hiddenOilIPType === "1"}
                                                required
                                            />
                                            <RadioInput
                                                label="SpGrOil"
                                                radioName="spGrOil"
                                                name="spGrOil"
                                                onInputChange={(e) => handleInputChange(e)}
                                                onRadioChange={(e) => handleRadioChange(e)}
                                                onBlur={(e) => handleBlur(e)}
                                                checked={tab3Input?.hiddenOilIPType === "1"}
                                                inputValue={fluidTab?.spGrOil ?? ""}
                                                disabled={tab3Input?.hiddenOilIPType === "0"}
                                                required
                                            />
                                        </div>
                                    }
                                />
                                <div className="flex justify-between text-neutral-25">
                                    <label>Oil cut</label>
                                    <label>{`${tab3Input?.oilCut} %`}</label>
                                </div>
                                <div className="flex justify-between text-neutral-25">
                                    <label>BOPD</label>
                                    <label>{`${tab3Input?.bopd} ${tab3Input?.actNameBOPD || 'bpd'}`}</label>
                                </div>
                                <div className="flex justify-between text-neutral-25">
                                    <label>Average composite SpGr</label>
                                    <label>{`${tab3Input?.averageCombinedSpGr}`}</label>
                                </div>
                                <div className="flex justify-between text-neutral-25">
                                    <label>Liquid phase composite SpGr</label>
                                    <label>{`${tab3Input?.liquidPhaseCombinedSpGr?.toString() === "NaN"
                                        ? "0"
                                        : tab3Input?.liquidPhaseCombinedSpGr ?? "0"
                                        }`}</label>
                                </div>
                                <TextInput
                                    label="Fluid viscosity"
                                    placeholder={
                                        "Enter fluid viscosity"
                                    }
                                    name="fluidViscosity"
                                    value={fluidTab?.fluidViscosity}
                                    onChange={(e) => handleInputChange(e)}
                                    onBlur={(e) => handleBlur(e)}
                                    unit={tab3Input?.actNameFluidViscosity || 'P'}
                                    required
                                />
                            </div>
                            </>
                        }
                    />
                    <Accordion
                        title="Gas properties"
                        isOpen={gasPropertyCollapse}
                        onToggle={() =>
                            handleCollapseChange(!gasPropertyCollapse, "gasProperty")
                        }
                        content={
                            <div className="flex flex-col gap-[16px] p-[12px]">
                                <Dropdown
                                    label="Gas availability"
                                    placeholder={
                                        "Enter availability"
                                    }
                                    options={gasAvailabilityOptions}
                                    onSelect={(option) => handleGasSelect(option)}
                                    selected={tab3Input?.gasAvailblty === "1" ? "1" : "2"}
                                    dropdownBgColor="bg-darkcolor-800"
                                    required
                                    bgColor="bg-transparent"
                                />
                            </div>
                        }
                    />
                    <Accordion
                        title="Gas volume"
                        isOpen={gasVolumeCollapse}
                        onToggle={() =>
                            handleCollapseChange(!gasVolumeCollapse, "gasVolume")
                        }
                        content={
                            <div className="flex flex-col gap-[16px] p-[12px]">
                                <RadioInput
                                    label="Gas production"
                                    radioName="gasProduction"
                                    name="gasProduction"
                                    unit={tab3Input?.actNameGasProduction || 'mcf'}
                                    onInputChange={(e) => handleInputChange(e)}
                                    onRadioChange={(e) => handleRadioChange(e)}
                                    onBlur={(e) => handleBlur(e)}
                                    inputValue={fluidTab?.gasProduction ?? "0"}
                                    checked={tab3Input?.gasAvailblty === "1" && tab3Input?.hiddenGasIPType === "0"}
                                    disabled={tab3Input?.hiddenGasIPType === "1" || tab3Input?.hiddenGasIPType === "2"}
                                    required
                                />
                                <RadioInput
                                    label="GOR"
                                    radioName="gor"
                                    name="gor"
                                    unit={tab3Input?.actNameGOR || 'scf/stb'}
                                    onInputChange={(e) => handleInputChange(e)}
                                    onRadioChange={(e) => handleRadioChange(e)}
                                    onBlur={(e) => handleBlur(e)}
                                    inputValue={fluidTab?.gor ?? "0"}
                                    checked={tab3Input?.hiddenGasIPType === "1"}
                                    disabled={tab3Input?.hiddenGasIPType === "0" || tab3Input?.hiddenGasIPType === "2"}
                                />
                                <RadioInput
                                    label="GLR"
                                    radioName="glr"
                                    name="glr"
                                    unit={tab3Input?.actNameGLR || 'scf/stb'}
                                    onInputChange={(e) => handleInputChange(e)}
                                    onRadioChange={(e) => handleRadioChange(e)}
                                    onBlur={(e) => handleBlur(e)}
                                    inputValue={fluidTab?.glr ?? "0"}
                                    checked={tab3Input?.hiddenGasIPType === "2"}
                                    disabled={tab3Input?.hiddenGasIPType === "0" || tab3Input?.hiddenGasIPType === "1"}
                                />
                            </div>
                        }
                    />
                    {tab3Input?.gasAvailblty !== "0" && (
                        <div className="flex flex-col gap-[16px]">
                            <TextInput
                                label="Specific gravity of gas"
                                placeholder="Enter specific gravity"
                                name="spGrGas"
                                value={fluidTab?.spGrGas ?? ""}
                                onChange={(e) => handleInputChange(e)}
                                onBlur={(e) => handleBlur(e)}
                                icon={helpIcons}
                                link={'/help/#specific-gravity-of-gas'}
                            />
                            <TextInput
                                label="Gas compressibility"
                                placeholder={
                                    "Enter gas compressibility"
                                }
                                name="gasCompressibility"
                                value={
                                    fluidTab?.gasCompressibility === 0
                                        ? ""
                                        : fluidTab?.gasCompressibility ?? ""
                                }
                                onChange={(e) => handleInputChange(e)}
                                onBlur={(e) => handleBlur(e)}
                                disabled={tab3Input?.hdnAutoGasCmpress === "1"}
                                icon={helpIcons}
                                link={'/help/#gas-compressibility'}
                            />
                            <Checkbox
                                label="Auto gas compressibility"
                                checked={tab3Input?.hdnAutoGasCmpress === "1"}
                                name="gasCompressibility"
                                onChange={(e) => handleCheckbox(e, "gasCompressibility")}
                            />
                            <TextInput
                                label="Bubble point"
                                placeholder="Enter bubble point"
                                name="bubblePoint"
                                value={fluidTab?.bubblePoint ?? ""}
                                unit={tab3Input?.actNameBubblePoint || 'psi'}
                                onChange={(e) => handleInputChange(e)}
                                onBlur={(e) => handleBlur(e)}
                                icon={helpIcons}
                                disabled={tab3Input?.hdnAutoBBlPnt === "1"}
                                required
                                link={'/help/#bubble-point-pressure'}
                            />
                            <Checkbox
                                label="Max bubble point "
                                checked={tab3Input?.hdnAutoBBlPnt === "1"}
                                name="bubblePoint"
                                onChange={(e) => handleCheckbox(e, "bubblePoint")}
                            />
                        </div>
                    )}
                    <Accordion
                        title="Others"
                        isOpen={othersCollapse}
                        onToggle={() => handleCollapseChange(!othersCollapse, "others")}
                        content={
                            <div className="flex flex-col gap-[16px] p-[12px]">
                                <TextInput
                                    label="Bottom hole temp"
                                    placeholder={
                                        "Enter bottom hole temp"
                                    }
                                    name="bottomHoleTemp"
                                    value={fluidTab?.bottomHoleTemp ?? ""}
                                    unit={tab3Input?.actNameBottomHoleTemp || '°F'}
                                    onChange={(e) => handleInputChange(e)}
                                    onBlur={(e) => handleBlur(e)}
                                    required
                                />
                                <TextInput
                                    label="Surface temperature"
                                    placeholder={
                                        "Enter surface temp"
                                    }
                                    name="surfaceTemperature"
                                    value={
                                        fluidTab?.surfaceTemperature ?? ""
                                    }
                                    unit={tab3Input?.actNameSurfaceTemp || '°F'}
                                    onChange={(e) => handleInputChange(e)}
                                    onBlur={(e) => handleBlur(e)}
                                    icon={helpIcons}
                                    required
                                    disabled={false}
                                    link={'/help/#surface-temperature'}
                                />
                            </div>
                        }
                    />
                    <Accordion
                        title="Correlations"
                        isOpen={correlationCollapse}
                        onToggle={() =>
                            handleCollapseChange(!correlationCollapse, "correlations")
                        }
                        content={
                            <div className="flex flex-col gap-[16px] p-[12px] w-full">
                                <Dropdown
                                    label="Region"
                                    placeholder={region || "Select region"}
                                    error=""
                                    bgColor="bg-transparent"
                                    dropdownBgColor="bg-darkcolor-800"
                                    onSelect={(option) => {
                                        updateRegion(option?.id);
                                        updateSelectedRegion(option?.name);
                                    }}
                                    options={regionList}
                                    selected={region ?? ""}
                                />
                            </div>
                        }
                    />
                </div>
            )}
            {notification?.show === true &&
                notification?.message !== "" &&
                notification?.type !== "" && (
                    <div className="fixed top-4 right-4 z-[1005] flex flex-col space-y-4">
                        <Notification
                            type={notification?.type}
                            message={notification?.message}
                            onClose={() =>
                                setNotification((prev) => ({
                                    ...prev,
                                    show: false,
                                    message: "",
                                    type: "",
                                }))
                            }
                            isOpen={
                                notification?.show === true &&
                                notification?.message !== "" &&
                                notification?.type !== ""
                            }
                            timeout={2000}
                        />
                    </div>
                )}
        </>
    );
};
export default Fluid;
